export default class RegisterAccordionLinks extends HTMLElement {

    private _accordionButton: HTMLButtonElement;
   
     constructor() {
         super();
         this._accordionButton = this.querySelector('button.accordion-trigger');

     }

     private handleAriaExpand () {
        this._accordionButton.setAttribute("aria-label", `Close ${this._accordionButton.dataset.accordionHeading}`);
        this._accordionButton.setAttribute("aria-expanded", "true");
         
     }
     private handleAriaCollapse () {
        this._accordionButton.setAttribute("aria-label", `Open ${this._accordionButton.dataset.accordionHeading}`);
        this._accordionButton.setAttribute("aria-expanded", "false");
     
    }

     private handleAccessibility () {
        if(this._accordionButton.classList.contains('open')){
            this.handleAriaCollapse();
            this._accordionButton.classList.remove('open');
        }
        else {
            this._accordionButton.classList.add('open');
            this.handleAriaExpand();
        }
     }

     private handleAccessibilityEvent: EventListener = (e: Event) => {
        this.handleAccessibility();    

     }
     
     connectedCallback() {

         this._accordionButton.addEventListener('click', this.handleAccessibilityEvent, false);
         
         if(this._accordionButton.classList.contains('open')) {
             this.handleAriaExpand();
         } else {
             this.handleAriaCollapse();
         }
     }
    
  }
  